import BaseService from "../../base/base_service";
import {GAME_POST_MESSAGES, GAME_REASON_CTA} from "./game_reason_consts";
import {SYSTEM_EVENTS} from "../../events/events";
import Event from "../../utils/event";
import _ from '../../utils/underscore';
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";
import {AreaType} from "@sparkware/uc-sdk-core";

class GameReasonService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GameReasonService';


    /**
     * Initialize game reason service.
     *
     * @param params
     */
    init(params) {
        super.init(params);
    }


    handleReason(reason) {
        let isGameClose = true;
        let numReason = parseInt(reason);
        let gameEvent = '';
        this.logger.debug('Handling reason => ', reason);
        if (isNaN(numReason)) {
            this.logger.error('Reason is undefined or not a number value', reason);
            return false;
        }
        switch (numReason) {
            case GAME_REASON_CTA.LOBBY:
                gameEvent = GAME_POST_MESSAGES.GOTO_LOBBY;
                break;
            case GAME_REASON_CTA.CASHIER_DEPOSIT:
                this.serviceFactory.cashierProxyService().openDeposit({
                    channel: {
                        source: CHANNEL_SOURCE.casinoClient,
                        area: AreaType.externalClick,
                        element: CHANNEL_ELEMENTS.urlParam
                    }
                });
                gameEvent = GAME_POST_MESSAGES.CASHIER;
                break;
           case GAME_REASON_CTA.LOBBY_FROM_GAME_LOAD:
               break;
            case GAME_REASON_CTA.HISTORY:
                this.serviceFactory.linksNavigationProxyService().openGamingHistoryPage();
                gameEvent = GAME_POST_MESSAGES.OPEN_GAME_HISTORY;
                break;
            case GAME_REASON_CTA.SELF_TEST_SWEDEN:
                this.serviceFactory.linksNavigationProxyService().openSelfTest();
                break;
            case GAME_REASON_CTA.OPEN_LIMITS_SWEDEN:
                this.serviceFactory.regulationService().getRegulation().openLimits();
                break;
            case GAME_REASON_CTA.SELF_EXCLUSION_SWEDEN:
                this.serviceFactory.linksNavigationProxyService().openSelfExclusion();
                break;
            case GAME_REASON_CTA.RESPONSIBLE_GAMING:
                this.serviceFactory.linksNavigationProxyService().openResponsibleGaming();

                break;
            default:
                isGameClose = false;
                break;
        }
        if (!_.isEmpty(gameEvent)) {
            this._tryToSendReasonPostMessage(gameEvent);
        }

        this._sendAnalytics(reason);

        return isGameClose;
    }

    _tryToSendReasonPostMessage(event) {
        let data = {EventId: event, type: event};
        if (window !== window.top) {
            this.serviceFactory.postMessageService().sendPostMessage(window.parent, data);
        }
    }

    _sendAnalytics(reason){
        //reason 600 is sent 3M time in 24H- we don't want to send it to GA - Hybrid second_web_view
        if(reason === 600)
            return;
        let analyticsData = {
            category: '[Technical-event]',
            action: 'GameReasonService',
            label: 'reason',
            value: reason
        };

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticsData);
    }
}

export default GameReasonService;